import { authenticatedApiRequest, cleanEmptyFields } from "./core";
import type { PaginatedResponse } from "./core";
import type { CreateSimpleSalesEntry, SimpleSalesEntry } from "@/types";

export interface SimpleSalesQueryParams {
  label_id?: string;
  page?: number;
  page_size?: number;
  q?: string;
}

export interface PaginatedSimpleSalesResponse extends PaginatedResponse {
  results: SimpleSalesEntry[];
}

const basePath = "/revenue/simple-sales";

function toQueryString(filters?: object): string {
  if (!filters) return "";
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters as Record<string, unknown>)) {
    if (value === undefined || value === null || value === "") continue;
    params.append(key, String(value));
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}

export const simpleSalesApi = {
  getEntries: async (filters?: SimpleSalesQueryParams): Promise<PaginatedSimpleSalesResponse> => {
    return authenticatedApiRequest<PaginatedSimpleSalesResponse>(
      `${basePath}${toQueryString(filters)}`,
    );
  },
  getEntry: async (id: string): Promise<SimpleSalesEntry> => {
    return authenticatedApiRequest<SimpleSalesEntry>(`${basePath}/${id}`);
  },
  createEntry: async (entry: CreateSimpleSalesEntry): Promise<SimpleSalesEntry> => {
    return authenticatedApiRequest<SimpleSalesEntry>(basePath, {
      method: "POST",
      body: JSON.stringify(cleanEmptyFields(entry)),
    });
  },
  patchEntry: async (
    id: string,
    updates: Partial<CreateSimpleSalesEntry>,
  ): Promise<SimpleSalesEntry> => {
    return authenticatedApiRequest<SimpleSalesEntry>(`${basePath}/${id}`, {
      method: "PATCH",
      body: JSON.stringify(updates),
    });
  },
  deleteEntry: async (id: string): Promise<void> => {
    await authenticatedApiRequest<void>(`${basePath}/${id}`, { method: "DELETE" });
  },
};
